import { render } from "./Week.component.vue?vue&type=template&id=a449bcf4"
import script from "./Week.component.vue?vue&type=script&lang=js"
export * from "./Week.component.vue?vue&type=script&lang=js"

import "./Week.component.vue?vue&type=style&index=0&id=a449bcf4&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn});
